import { Instance } from 'mobx-state-tree';
import model from './model';

const DataRamSensor = model;

export interface IDataRamSensor extends Instance<typeof DataRamSensor> {}

export default DataRamSensor;
